import Alpine from 'alpinejs';
import AlpineCollapsePlugin from '@alpinejs/collapse';
import AlpineFocusPlugin from '@alpinejs/focus';
import Tabs from '@/components/tabs/tabs';
import Collapse from '@/components/collapse/collapse';
import Filter from '@/components/filter/filter';
import Slider from '@/components/slider/slider';
import Scroll from '@/components/scroll/scroll';
import FirstLevelMenu from '@/components/menu/first-level-menu';
import SecondLevelMenu from '@/components/menu/second-level-menu';
import Video from '@/components/video/video';
import Analytic from '@/components/analytic/analytic';
import CustomerFormRedirect from '@/components/customer-form-redirect/customer-form-redirect';

export default () => {
  Alpine.plugin(AlpineCollapsePlugin);
  Alpine.plugin(AlpineFocusPlugin);

  Alpine.store('analytic', Analytic);

  Alpine.data('collapse', Collapse);
  Alpine.data('filter', Filter);
  Alpine.data('firstLevelMenu', FirstLevelMenu);
  Alpine.data('secondLevelMenu', SecondLevelMenu);
  Alpine.data('scroll', Scroll);
  Alpine.data('slider', Slider);
  Alpine.data('tabs', Tabs);
  Alpine.data('video', Video);
  Alpine.data('customerFormRedirect', CustomerFormRedirect);

  // Prevent Alpine to start multiple times
  if (!window.Alpine) {
    window.Alpine = Alpine;
    Alpine.start();
  }
};
